import { forwardRef, ForwardedRef } from "react";
import { useLocation } from "react-router-dom";

import { useAnalytics } from "src/hooks/useAnalytics";
import { useTrackedLinkClickHandler } from "src/hooks/useTrackedLinkClickHandler";

import LinkButton, { LinkButtonProps } from "./LinkButton";

const TrackedLinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  (
    { to, href, onClick, label, children, disabled, ...props }: LinkButtonProps,
    ref: ForwardedRef<HTMLAnchorElement>,
  ) => {
    const location = useLocation<unknown>();
    const { trackButtonClicked } = useAnalytics();

    const handleClick = useTrackedLinkClickHandler<unknown>({
      to,
      href,
      onClick,
      children,
      disabled,
      location,
      elementType: "LinkButton",
      label,
      tracker: trackButtonClicked,
    });

    return (
      <LinkButton
        ref={ref}
        to={to}
        href={href}
        onClick={handleClick}
        label={label}
        disabled={disabled}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {children}
      </LinkButton>
    );
  },
);

export default TrackedLinkButton;
